import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotificationType } from 'app/components/Notification/types'
import { CdnInfo } from 'domain/CdnInfo'

const generalSlice = createSlice({
    name: 'generalSlice',
    initialState: {
        notification: {
            type: 'info',
            header: '',
            message: '',
        } as NotificationType,
        isShowNotification: false,
        cdnInfo: {
            imageCdn: {
                enable: false,
            },
            applicationCdn: {
                enable: false,
            },
        } as CdnInfo,
    },
    reducers: {
        setNotification: (state, action: PayloadAction<NotificationType>) => {
            state.notification = action.payload
        },
        setIsShowNotification: (state, action: PayloadAction<boolean>) => {
            state.isShowNotification = action.payload
        },
        setCdnInfo: (state, action: PayloadAction<CdnInfo>) => {
            state.cdnInfo = action.payload
        },
    },
})

export const { setNotification, setIsShowNotification, setCdnInfo } =
    generalSlice.actions
export default generalSlice.reducer
